import { Header } from '@opengov/component-library/dist';
import cx from 'classnames2';
import React, { useMemo } from 'react';
import { useRouteError } from 'react-router-dom';
import { LandscapeSvg } from './LandscapeSvg';
import styles from './RouteErrorElement.scss';
import { IComposeAppRendererParams } from '@opengov/compose-app/renderApp';
import { reportLocaleText } from '../../../application/common/locale';

enum ErrorMessage {
  NotFound = 'NotFound',
  InternalServerError = 'InternalServerError'
}

const ErrorCodes = {
  [ErrorMessage.NotFound]: '404',
  [ErrorMessage.InternalServerError]: '500'
};

export function RouteErrorElement({ store }: { readonly store: IComposeAppRendererParams<object>['store'] }) {
  const error = useRouteError() as Error;
  const errorMessage = error.message as ErrorMessage;
  const errorCode = ErrorCodes[errorMessage] || '';
  const locale = useMemo(() => reportLocaleText(store.getState()).routeErrorElement, [store]);

  return (
    <div className={cx(styles.container, { [styles.withErrorCode]: errorCode })} data-test="routeErrorElement">
      <div className={styles.innerContainer}>
        {errorCode ? (
          <div className={styles.errorCode} data-test="routeErrorElementErrorCode">
            {errorCode}
          </div>
        ) : null}

        <LandscapeSvg />
        <Header variant="h1" className={styles.header}>
          {errorMessage === ErrorMessage.NotFound ? locale.pageDoesNotExist : locale.somethingWentWrong}
        </Header>
        <Header variant="h3" className={styles.supportText}>
          {`${locale.tryRefreshingPage} ${locale.or} `}
          <a href="https://support.opengov.com/hc/en-us" target="_blank" rel="noopener noreferrer">
            {locale.contactSupport}
          </a>{' '}
          {locale.ifErrorPersists}
        </Header>
      </div>
    </div>
  );
}
